import React, { Component } from 'react';
import cx from 'classnames';
import $ from 'jquery';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { toJS } from 'mobx';
import {
  Dropdown,
  Loader,
  Label,
  Icon,
  Checkbox,
  Button,
  ButtonGroup,
  Modal,
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import WithRouter from '../Extensions/WithRouter';
import api from '../../api';
import ClarLoader from '../Loader/Loader';
import progress from '../../images/icons/progress_ica.gif';
import search from '../../images/components/left_menu/searchIcon.png';
import add from '../../images/components/left_menu/add.png';
import foldImg from '../../images/components/left_menu/foldIcon.png';
import expandImg from '../../images/components/left_menu/expandIcon.png';
//import bulletImg from '../../images/components/left_menu/bullet.png';
import './ScanNavBar.css';
import NewScanModal from '../StartScan/NewScanModal';
import FilterFormWithSaveModal from './FilterFormWithSaveModal';
import ImportPopup from '../SBOM/Import/ImportPopup';

class ScanNavBar extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.updateInterval = null;
    this.currentCount = 0;
    this.activeBookmark = 0;

    this.setNavigationBarRef = (element) => {
      this.navigationBar = element;
    };
    this.setRecentListScrollRef = (element) => {
      this.recentListScroll = element;
    };
    this.setBookmarkListScrollRef = (element) => {
      this.bookmarkListScroll = element;
    };

    this.state = {
      pageSize: 20,
      currentPage: 1,
      isOpenScan: props.isOpenScan,
      error: null,
      hasMore: true,
      isLoading: false,
      isLoadingBookmark: false,
      isLoadingTree: false,
      isSelectable: false,
      isShowMoreLoading: false,
      quotaArray: [],
      isShowQuota: false,
      recentList: [],
      projectList: [],
      uploadedDataList: [],
      bookmarkDataList: [],
      activeIndex: [],
      hasMoreProject: false,
      hasMoreProjectVersion: [],
      hasMoreReport: [],
      currentSorted: 'uploaded',
      activeTab: 'recent',
      activeTabBottom: 'projects',
      targetObject: 'project',
      parentId: 0,
      errSearch: false,
      loadingIndex: '',
      uploadedCount: 0,
      activeBookmark: 0,
      projectSize: 20,
      projectVersionSize: 20,
      projectReportSize: 20,
      selectedIndex: {
        project: [],
        project_version: [],
      },
      queryString: '',
      filterList: [],
      selectedFilter: '',
      currentIdWithDelete: '',
      isOpenMFF: false,
      isOpenAlertModal: false,
      isOpenSaveFilter: false,
      isLoadingWithModal: false,
      isErrorWithAPI: false,
      isRequestSave: false,
      rowData: [],
      saveFilterArray: [],
      isOpenImport: false,
    };
    this.handleSortingChange = this.handleSortingChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleBookmarkScroll = this.handleBookmarkScroll.bind(this);
    this.handleScanOpen = this.handleScanOpen.bind(this);
    this.handleSbomImportOpen = this.handleSbomImportOpen.bind(this);
    this.handleScanClose = this.handleScanClose.bind(this);
    this.handleNav = this.handleNav.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleBookmarkNav = this.handleBookmarkNav.bind(this);
    this.handleEditBookmark = this.handleEditBookmark.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.initArrayData = this.initArrayData.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.getBookmarkData = this.getBookmarkData.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
    this.selectedTags = this.selectedTags.bind(this);
    this.addParamsArrayValue = this.addParamsArrayValue.bind(this);
    this.updateExistingParamsArrayValue = this.updateExistingParamsArrayValue.bind(this);
    this.removeExistingParamsArrayValue = this.removeExistingParamsArrayValue.bind(this);
    this.toggleSelectMode = this.toggleSelectMode.bind(this);
    this.navigateProjectSettings = this.navigateProjectSettings.bind(this);
    this.saveProjectFilter = this.saveProjectFilter.bind(this);
    this.initProjectFilter = this.initProjectFilter.bind(this);
    this.handleLoadFilterChange = this.handleLoadFilterChange.bind(this);
    this.handleDeleteFilterChange = this.handleDeleteFilterChange.bind(this);
    this.handleSaveFilterChange = this.handleSaveFilterChange.bind(this);
    this.handleSaveFilterCallback = this.handleSaveFilterCallback.bind(this);
    this.generateTreeData = this.generateTreeData.bind(this);
    this.updateFilterStatus = this.updateFilterStatus.bind(this);
    this.updateSelectedIndexFromOthers = this.updateSelectedIndexFromOthers.bind(this);
    this.handleSbomImportClose = this.handleSbomImportClose.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeMFFModal = this.closeMFFModal.bind(this);
  }

  componentDidMount() {
    const { location } = this.props;

    if (this.navigationBar && location.pathname.indexOf('result') > -1) {
      this.onUpdateLoading();
      this.setDragEvent();

      this.updateInterval = setInterval(() => {
        this.onUpdateBottomList();
      }, 2000);
    }

    $(document).on('mouseover', '.left_menu .menu_list ul li .name, .left_menu .projects_list_wrap .projects_list ul li a span, .left_menu .newest .dropdown .item span', function handleMouseOver() {
      const $this = $(this);
      if (!$this.attr('title') && (this.offsetWidth < this.scrollWidth || $this.hasClass('name'))) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      location, isOpenScan, searchParams, state
    } = this.props;
    const {
      recentList, bookmarkDataList, isLoading, uploadedDataList,
      projectList, activeTab, activeTabBottom, queryString, selectedIndex, filterList,
    } = this.state;
    const [URLSearchParams] = searchParams;

    if (prevProps.isOpenScan !== isOpenScan) {
      this.setState({ isOpenScan });
    }

    const shouldUpdateUI = prevState.recentList.length !== recentList.length
      || prevState.bookmarkDataList.length !== bookmarkDataList.length
      || prevState.uploadedDataList.length !== uploadedDataList.length
      || prevState.projectList.length !== projectList.length
      || prevState.activeTab !== activeTab
      || prevState.activeTabBottom !== activeTabBottom;

    if (shouldUpdateUI) {
      this.setMenuElem();
    }

    if (!prevState.isLoading && isLoading) {
      //if (projectList.length === 0) {
      //this.getLeftProjectList();
      //}
      if (filterList.length === 0) {
        this.getProjectFilters();
      }

      this.getLeftProjectList();
      this.getQuotaData();
      this.getRecentData();
      this.setState({ isLoading: false });
    }

    if (prevProps.location.pathname !== location.pathname) {
      if (location.pathname.includes('/results/overview')) {
        this.onUpdateLoading();
      }

      //setTimeout(this.initArrayData, 100);

      [this.recentListScroll, this.bookmarkListScroll].forEach((scroll) => {
        if (scroll && scroll.view) {
          scroll.view.scrollTop = 0;
        }
      });
      this.setMenuElem();

      if (!location.pathname.includes('/results/overview') && queryString !== '') {
        this.setState({ queryString: '' });
      }

      if (!location.pathname.includes('/results/overview') && URLSearchParams.size !== 0 && state.pages.isUpdateFromTree) {
        this.setState({
          isOpenSaveFilter: true,
          isLoadingWithModal: true,
        }, () => {
          this.updateSelectedIndexFromOthers(location);
        });
      }
    }

    const didSelectedIndexChange = prevState.selectedIndex.project.length !== selectedIndex.project.length
      || prevState.selectedIndex.project_version.length !== selectedIndex.project_version.length;

    if (didSelectedIndexChange) {
      state.pages.setSelectedIndexValue(selectedIndex);
    }
  }

  componentWillUnmount() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
    $(document).off('mouseover', '.left_menu .menu_list ul li .name, .left_menu .projects_list_wrap .projects_list ul li a span, .left_menu .newest .dropdown .item span');
  }

  handleCheckChange(e, value, target, parentId) {
    const { selectedIndex, activeIndex, projectList } = this.state;
    const { searchParams } = this.props;
    const [URLSearchParams, setSearchParams] = searchParams;

    if (target === 'project') {
      if (selectedIndex.project.indexOf(value) > -1) {
        const filtered = selectedIndex.project.filter((item) => {
          return item !== value;
        });

        if (activeIndex.indexOf(value) > -1) {
          const findCurrentProjectIndex = projectList.findIndex((item) => {
            return item.data.id === value;
          });

          const projectVersionIds = projectList[findCurrentProjectIndex].children.map((item) => {
            return item.data.id;
          });
          const filteredProjectVersion = selectedIndex.project_version.filter((item) => {
            return projectVersionIds.indexOf(item) === -1;
          });

          setSearchParams(this.removeExistingParamsArrayValue(URLSearchParams, target, value));
          return this.setState({
            selectedIndex: {
              ...selectedIndex,
              project: filtered,
              project_version: filteredProjectVersion,
            }
          });
        }
        setSearchParams(this.removeExistingParamsArrayValue(URLSearchParams, target, value));
        return this.setState({
          selectedIndex: {
            ...selectedIndex,
            project: filtered,
          },
        });
      }
      if (activeIndex.indexOf(value) > -1) {
        const findCurrentProjectIndex = projectList.findIndex((item) => {
          return item.data.id === value;
        });

        const projectVersionIds = projectList[findCurrentProjectIndex].children.map((item) => {
          return item.data.id;
        });

        const currentSelctedProjectVersionIds = selectedIndex.project_version;
        projectVersionIds.map((item) => {
          return currentSelctedProjectVersionIds.push(item);
        });

        this.selectedTags(target, value);
        return this.setState({
          selectedIndex: {
            ...selectedIndex,
            project: [...selectedIndex.project, value],
            project_version: currentSelctedProjectVersionIds,
          }
        });
      }
      this.selectedTags(target, value);
      return this.setState({
        selectedIndex: {
          ...selectedIndex,
          project: [...selectedIndex.project, value],
        }
      });
    }

    if (target === 'project_version') {
      if (selectedIndex.project_version.indexOf(value) > -1) {
        const filtered = selectedIndex.project_version.filter((item) => {
          return item !== value;
        });

        if (selectedIndex.project.indexOf(parentId) > -1) {
          const filteredProject = selectedIndex.project.filter((item) => {
            return item !== parentId;
          });
          setSearchParams(this.removeExistingParamsArrayValue(URLSearchParams, target, value, parentId));
          return this.setState({
            selectedIndex: {
              ...selectedIndex,
              project: filteredProject,
              project_version: filtered,
            },
          });
        }
        setSearchParams(this.removeExistingParamsArrayValue(URLSearchParams, target, value, parentId));
        return this.setState({
          selectedIndex: {
            ...selectedIndex,
            project_version: filtered,
          },
        });
      }

      const currentProjectIndex = projectList.findIndex((item) => {
        return item.data.id === parentId;
      });

      const projectVersionIds = projectList[currentProjectIndex].children.map((item) => {
        return item.data.id;
      });

      const newSelectedIndexWithProjectVersion = [...selectedIndex.project_version, value];
      const currentProjectVersionIds = projectVersionIds.filter((item) => {
        return newSelectedIndexWithProjectVersion.indexOf(item) === -1;
      });

      if (currentProjectVersionIds.length === 0) {
        this.selectedTags(target, value, parentId);
        return this.setState({
          selectedIndex: {
            ...selectedIndex,
            project: [...selectedIndex.project, parentId],
            project_version: [...selectedIndex.project_version, value],
          }
        });
      }
      this.selectedTags(target, value, parentId);
      return this.setState({
        selectedIndex: {
          ...selectedIndex,
          project_version: [...selectedIndex.project_version, value],
        }
      });
    }
  }

  handleEditBookmark() {
    const { navigate } = this.props;
    navigate('my_page/bookmark');
  }

  handleScroll = (event) => {
    const {
      getUploadedData,
      state: {
        error, isLoading, hasMore, currentPage
      },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrolledToBottom) {
      getUploadedData(currentPage + 1);
    }
  };

  handleBookmarkScroll = (event) => {
    const {
      getBookmarkData,
      state: {
        error, isLoadingBookmark, hasMore, currentPage
      },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (error || isLoadingBookmark || !hasMore) {
      return;
    }
    if (scrolledToBottom) {
      getBookmarkData(currentPage + 1);
    }
  };

  handleScanOpen() {
    const { handleScanOpen } = this.props;
    handleScanOpen();
  }

  handleScanClose() {
    const { handleScanClose } = this.props;
    handleScanClose();
  }

  handleSbomImportOpen() {
    this.setState({
      isOpenImport: true,
    });
  }

  handleSbomImportClose() {
    this.setState({
      isOpenImport: false,
    });
  }

  handleNav = (idReport, path) => {
    const { navigate } = this.props;
    const basePath = `/results/${path}`;
    const fullPath = `${basePath}/${path === 'policy' ? 'project' : 'binary'}/${idReport}`;
    navigate(fullPath);
  };

  handleBookmarkNav = (ObjectId, path, target, projectName, projectVersionName) => {
    const { state, navigate } = this.props;

    const navigateToBinaryOrProject = (isPolicy, uploadedFileId) => {
      const type = isPolicy ? 'project' : 'binary';
      navigate(`/results/${path}/${type}/${uploadedFileId}`);
    };

    switch (target) {
    case 'report':
      navigateToBinaryOrProject(path === 'policy', ObjectId.uploaded_file_id);
      break;
    case 'project':
      state.report.setNavBookmark(ObjectId, projectName);
      navigate(`/results/${path}/project`);
      break;
    case 'project_version':
      state.report.setNavBookmark(ObjectId, projectName, projectVersionName);
      navigate(`/results/${path}/project`);
      break;
    default:
      console.warn(`Unhandled target type: ${target}`);
      break;
    }

    return null;
  };

  handleSortingChange(e, data) {
    const { activeTabBottom, currentSorted } = this.state;

    if (currentSorted === data.value) {
      return;
    }

    const newState = {
      currentSorted: data.value,
    };

    if (activeTabBottom === 'files') {
      newState.uploadedDataList = [];
    } else {
      newState.projectList = [];
      newState.activeIndex = [];
    }

    this.setState(newState, () => {
      if (activeTabBottom === 'files') {
        this.getUploadedData();
      } else {
        this.getLeftProjectList();
      }
    });
  }

  handleLoadFilterChange(e, { value }) {
    const { selectedFilter, filterList, projectList } = this.state;
    const { t } = this.props;
    if (e.target.classList.length !== 0) {
      let i = 0;
      for (i; i < e.target.classList.length; i++) {
        if (e.target.classList[i].indexOf('cancel') > -1 || e.target.classList[i].indexOf('icon') > -1) {
          return;
        }
      }
    }

    if (selectedFilter === value) {
      return;
    }

    const findSelectedindex = filterList.findIndex((o) => {
      return o.value === value;
    });

    //check inactive project
    if (filterList[findSelectedindex].projects.length !== 0) {
      const activeProject = projectList.filter((item) => {
        return filterList[findSelectedindex].projects.includes(item.data.id);
      });

      if (activeProject.length !== filterList[findSelectedindex].projects.length) {
        this.modalAction = t('modal.title.attention');
        this.modalBody = t('navibar.inactive_projects');

        return this.setState({
          isOpenAlertModal: true,
        });
      }
    }

    this.modalAction = t('modal.title.notice');
    this.modalBody = t('navibar.load_filters');

    this.setState({
      isOpenSaveFilter: true,
      isLoadingWithModal: true,
      selectedFilter: value
    }, () => {
      this.updateFilterStatus(filterList[findSelectedindex]);
    });
  }

  handleDeleteFilterChange = (e, data) => {
    const { t } = this.props;
    this.modalAction = t('modal.title.notice');
    this.modalBody = t('navibar.delete_this_filter');

    this.setState({
      isOpenSaveFilter: true,
      isRequestSave: false,
      currentIdWithDelete: data.id,
    });
  };

  handleSaveFilterChange = () => {
    const { searchParams, t } = this.props;
    const [URLSearchParams] = searchParams;

    if (URLSearchParams.size === 0) {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('navibar.filter_at_least_one');
      return this.setState({
        isOpenAlertModal: true,
      });
    }
    const data = this.generateTreeData();

    this.setState({
      isOpenMFF: true,
      rowData: data,
    });
  };

  handleSaveFilterCallback = (obj) => {
    const { t } = this.props;
    this.modalAction = t('modal.title.attention');
    this.modalBody = t('navibar.save_this_filter');
    this.setState({
      saveFilterArray: obj,
      isOpenSaveFilter: true,
      isLoadingWithModal: false,
      isErrorWithAPI: false,
      isRequestSave: true,
    });
  };

  handleSearch(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
              });
            }, 1500);
          }
        );
        return false;
      }

      this.setState(
        {
          searchKeyword: event.target.value,
          targetObject: 'project',
          parentId: 0,
          projectList: [],
          activeIndex: [],
        },
        () => {
          this.getLeftProjectList();
        }
      );
    }
  }

  handleTabChange(e) {
    const { activeTab } = this.state;
    const { t } = this.props;

    if (e.target.text === t('my_page.title.recent')) {
      if (activeTab === 'recent') {
        return;
      }
      this.setState(
        {
          activeTab: 'recent',
          bookmarkDataList: [],
        },
        () => {
          this.getRecentData();
        }
      );
    }

    if (e.target.text === t('my_page.title.bookmarks')) {
      if (activeTab === 'bookmark') {
        return;
      }
      this.setState(
        {
          activeTab: 'bookmark',
          recentList: [],
        },
        () => {
          this.getBookmarkData();
        }
      );
    }
  }

  onUpdateLoading() {
    this.setState({
      isLoading: true,
    });
  }

  onUpdateBottomList() {
    const { state } = this.props;
    const {
      uploadedCount, activeBookmark, activeTab, activeTabBottom
    } = this.state;

    this.currentCount = state.report.uploadedCount || 0;
    this.activeBookmark = state.report.activeBookmark || 0;

    if (this.currentCount !== uploadedCount) {
      if (activeTabBottom === 'files') {
        this.initUpoloadedList();
      } else {
        this.onUpdateProjectList();
      }
    }

    if (this.activeBookmark !== activeBookmark) {
      if (activeTab === 'bookmark') {
        this.initBookmarkList();
      }
    }
  }

  async onUpdateProjects(ids) {
    const { projectList, searchKeyword, projectSize } = this.state;
    const cloneArray = [...projectList];
    try {
      const response = await api.getLeftProjectList({
        search: searchKeyword,
        target_object: 'project',
        object_parent_id: 0,
        page: 1,
        limit: projectSize,
        order: 'uploaded',
      });
      let newState = [];
      let updatedData = [];
      const nextProjectList = response.response.map((item) => {
        return {
          data: item,
          children: [],
        };
      });

      ids.map((parentId, index) => {
        const legacyArray = cloneArray.filter((item) => {
          return item.data.target_id.project_id === parentId;
        });

        const updatedIndex = nextProjectList.findIndex((item) => {
          return item.data.target_id.project_id === parentId;
        });

        if (index === 0) {
          updatedData = Update(nextProjectList[updatedIndex], { $set: legacyArray[0] });
          newState = Update(nextProjectList, {
            $splice: [[updatedIndex, 1, updatedData]],
          });
        } else {
          updatedData = Update(newState[updatedIndex], { $set: legacyArray[0] });
          newState = Update(newState, {
            $splice: [[updatedIndex, 1, updatedData]],
          });
        }
        return newState;
      });

      this.setState({
        isLoadingTree: false,
        nextProjectPage: response.pagination.next,
        projectSize: response.pagination.per_page,
        hasMoreProject: response.pagination.next !== null,
        projectList: newState,
        loadingIndex: '',
        isShowMoreLoading: false,
        uploadedCount: this.currentCount,
      });
    } catch (err) {
      console.log(err);
      this.setState({
        uploadedCount: this.currentCount,
      });
    }
  }

  async onUpdateProjectVersion(ids) {
    //version list {"search":"","target_object":"project_version","object_parent_id":4,"page":1,"limit":20,"order":"uploaded"}
    const {
      projectList, projectVersionSize, currentSorted, searchKeyword, hasMoreProjectVersion
    } = this.state;
    const cloneArray = [...projectList];
    let versionArray = [];

    try {
      await ids.map((parentId, i) => {
        return api.getLeftProjectList({
          search: searchKeyword,
          target_object: 'project_version',
          object_parent_id: parentId,
          page: 1,
          limit: projectVersionSize,
          order: currentSorted,
        }).then((response) => {
          const nextProjectList = response.response.map((item) => {
            return {
              data: item,
              children: [],
            };
          });

          const versionIndex = projectList.findIndex((item) => {
            return item.data.target_id.project_id === parentId;
          });

          let newData;
          const isNext = response.pagination.next !== null;
          const newObject = {
            parentIndex: versionIndex,
            isNext,
          };

          if (hasMoreProjectVersion.length !== 0) {
            newData = hasMoreProjectVersion.filter((item) => {
              return item.parentIndex !== versionIndex;
            });
          } else {
            newData = hasMoreProjectVersion;
          }

          if (i === 0) {
            versionArray = Update(cloneArray, {
              [versionIndex]: {
                children: {
                  $set: nextProjectList,
                },
              },
            });
          } else {
            versionArray = Update(versionArray, {
              [versionIndex]: {
                children: {
                  $set: nextProjectList,
                },
              },
            });
          }

          this.setState({
            isLoadingTree: false,
            projectList: versionArray,
            hasMoreProjectVersion: [...newData, newObject],
            loadingIndex: '',
            isShowMoreLoading: false,
            uploadedCount: this.currentCount,
          });
        });
      });
    } catch (err) {
      console.log(err);
      this.setState({
        uploadedCount: this.currentCount,
      });
    }
  }

  async onUpdateProjectList() {
    const { projectList } = this.state;
    const expandedTree = projectList.filter((item) => {
      return item.children.length > 0;
    });

    if (expandedTree.length === 0) {
      return this.initProjectList(); //project list update all
    }

    const expandedIds = [];
    const parentIds = [];
    const hasReportIds = [];

    expandedTree.map((item) => {
      return expandedIds.push(item.data.target_id.project_id);
    });

    await this.onUpdateProjects(expandedIds);

    const expandReportTree = expandedTree.filter((item) => {
      const expandReport = item.children.filter((version) => {
        return version.children.length > 0;
      });
      return expandReport.length > 0;
    });

    if (expandReportTree.length === 0) {
      expandedTree.map((item) => {
        return parentIds.push(item.data.target_id.project_id);
      });
      return this.onUpdateProjectVersion(parentIds);
    }

    expandReportTree.map((item) => {
      return hasReportIds.push(item.data.target_id.project_id);
    });

    //this.onUpdateReport(hasReportIds);
  }

  getQuotaData = async () => {
    const { t } = this.props;
    await api
      .getQuotaData()
      .then((response) => {
        const data = response.response;
        this.setState({
          quotaArray: data.quota.quota_result,
          isShowQuota: data.quota.allow_show_quota,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
        });
      });
  };

  getRecentData = () => {
    const { t } = this.props;
    api
      .getRecentData()
      .then((response) => {
        const data = response.response;
        this.setState({
          recentList: data,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
        });
      });
  };

  getUploadedData = async (pageNo, limit) => {
    const {
      pageSize, searchKeyword, currentSorted, uploadedDataList
    } = this.state;
    const { state, t } = this.props;
    const page = pageNo || 1;
    const perPage = limit || pageSize;

    if (page !== 1) {
      this.setState({
        //isLoadingFiles: true,
      });
    }

    await api
      .getUploadedData(
        {
          search: searchKeyword,
          page,
          limit: perPage,
          order: currentSorted,
        }
      )
      .then((response) => {
        if (uploadedDataList.length !== 0 && response.pagination.current === 1) {
          return false;
        }
        const nextUploadedDataList = response.response.map((item) => {
          return {
            extraData: item.extra_data,
            id: item.id,
            isPolicyViolation: item.is_policy_violation,
            isRealTimeUpdate: item.is_realtime_update,
            name: item.name,
            targetId: item.target_id.uploaded_file_id,
            uploadedAt: item.uploaded_at,
            uploadedGrade: item.uploaded_grade,
            viewPoint: item.view_point,
          };
        });
        this.setState({
          //totalCount: response.count,
          currentPage: response.pagination.current,
          //prevPage: response.pagination.previous,
          //nextPage: response.pagination.next,
          pageSize: response.pagination.per_page,
          //totalPage: response.pagination.pages,
          //currentCount: response.pagination.count,
          hasMore: response.pagination.next !== null,
          //isLoadingFiles: false,
          uploadedDataList: [...uploadedDataList, ...nextUploadedDataList],
          uploadedCount: state.report.uploadedCount,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          //isLoadingFiles: false,
        });
      });
  };

  getLeftProjectList = (pageNo, limit, versionIndex, reportIndex) => {
    const {
      projectSize, searchKeyword, currentSorted, targetObject, parentId, projectList, hasMoreProjectVersion, selectedIndex, activeIndex
    } = this.state;
    const page = pageNo || 1;
    const perPage = limit || projectSize;
    const { t, state } = this.props;

    let loadingIndex = '';
    if (page === 1) {
      loadingIndex = targetObject === 'project' ? 'project' : `${versionIndex}-${targetObject === 'report' ? `${reportIndex}-` : ''}${targetObject}`;
    }

    this.setState({
      isLoadingTree: page === 1,
      isShowMoreLoading: page !== 1,
      ...(loadingIndex && { loadingIndex }),
    });

    api.getLeftProjectList({
      search: searchKeyword,
      target_object: targetObject,
      object_parent_id: parentId,
      page,
      limit: perPage,
      order: currentSorted,
    }).then((response) => {
      const nextProjectList = response.response.map((item) => { return { data: item, children: [] }; });
      const { pagination } = response;

      if (targetObject === 'project') {
        this.updateProjectListState(projectList, nextProjectList, response.pagination, state, page);
      } else if (targetObject === 'project_version') {
        this.updateProjectVersionState(projectList, nextProjectList, versionIndex, pagination, selectedIndex, activeIndex, hasMoreProjectVersion, state, page);
      }
    }).catch((err) => {
      console.log(err);
      this.setState({
        error: t('modal.error.error_load'), isLoadingTree: false, loadingIndex: '', isShowMoreLoading: false
      });
    });
  };

  getProjectFilters() {
    api
      .getProjectFilters()
      .then((res) => {
        const data = res.response.map((item) => {
          return {
            key: item.id,
            text:
  <div>
    <span>
      {item.name}
    </span>
    <a
      className="cancel_icon"
      onClick={(e) => {
        return this.handleDeleteFilterChange(e, item);
      }}
      onKeyUp={(e) => {
        return this.handleDeleteFilterChange(e, item);
      }}
    >
      <Icon name="cancel" />
    </a>
  </div>,
            value: item.id,
            projects: item.projects,
            project_versions: item.project_versions,
            created_at: item.created_at,
          };
        });

        this.setState({
          filterList: data,
          selectedFilter: '',
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getBookmarkData(pageNo, limit) {
    const { t } = this.props;
    const { pageSize } = this.state;
    const page = pageNo || 1;
    const perPage = limit || pageSize;

    if (page !== 1) {
      this.setState({
        isLoadingBookmark: true,
      });
    }

    api
      .getBookmarkData(page, perPage)
      .then((response) => {
        const nextBookmarkDataList = response.response.map((item) => {
          return {
            id: item.id,
            name: item.name,
            targetObject: item.target_object,
            targetId: item.target_id,
            viewPoint: item.view_point,
            extraData: item.extra_data,
          };
        });
        this.setState((prevState) => {
          return {
            totalCount: response.count,
            currentPage: response.pagination.current,
            prevPage: response.pagination.previous,
            nextPage: response.pagination.next,
            pageSize: response.pagination.per_page,
            totalPage: response.pagination.pages,
            currentCount: response.pagination.count,
            hasMore: response.pagination.next !== null,
            isLoadingBookmark: false,
            bookmarkDataList: [...prevState.bookmarkDataList, ...nextBookmarkDataList],
          };
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoadingBookmark: false,
        });
      });
  }

  getMoreListData = (index, targetId, targetObject) => {
    const {
      projectList, projectVersionSize, projectReportSize, nextProjectPage, projectSize
    } = this.state;
    if (targetObject === 'project_version') {
      const nextPage = (Math.ceil(projectList[index].children.length) / projectVersionSize) + 1;
      this.setState({
        targetObject,
        parentId: targetId,
      }, () => {
        this.getLeftProjectList(nextPage, projectVersionSize, index);
      });
    } else if (targetObject === 'report') {
      const string = index.split('-');
      const nextPage = (Math.ceil(projectList[Number(string[0])].children[Number(string[1])].children.length) / projectReportSize) + 1;
      this.setState({
        targetObject,
        parentId: targetId,
      }, () => {
        this.getLeftProjectList(nextPage, projectReportSize, Number(string[0]), Number(string[1]));
      });
    } else {
      this.setState({
        targetObject: 'project',
        parentId: 0,
      }, () => {
        this.getLeftProjectList(nextProjectPage, projectSize);
      });
    }
  };

  setDragEvent = () => {
    let dragging = false;
    const main = $('.left_menu_content.content_bottom');
    const ghostbar = $(
      '<div>',
      {
        id: 'left_menu_ghostbar',
        css: {
          width: main.outerWidth(),
          top: main.offset().top,
          left: main.offset().left
        }
      }
    );

    $('.dragbar').mousedown((e) => {
      e.preventDefault();
      dragging = true;
      ghostbar.appendTo('body');
      $(document).mousemove((el) => {
        ghostbar.css('top', el.pageY + 2);
      });
    });

    $(document).mouseup((e) => {
      if (dragging) {
        const pageY = e.pageY - $('.left_menu_contents_wrap').offset().top;
        const percentage = (pageY / $('.left_menu_contents_wrap').height()) * 100;

        this.setMenuElem(percentage);

        $('#left_menu_ghostbar').remove();
        $(document).unbind('mousemove');
        dragging = false;
      }
    });
  };

  setMenuElem(percentage) {
    const tabHeight = 24 + 5;

    let tempHeight = $(window).height() * 0.85;

    if (tempHeight < 600) {
      tempHeight = 600;
    }
    if (tempHeight > 1000) {
      tempHeight = 1000;
    }

    $('.left_menu').css('height', tempHeight);
    $('.left_menu_contents_wrap').css('height', tempHeight - 30 - 65 - 20);

    if (!percentage) {
      percentage = 35;
    }

    if (percentage < 20) {
      percentage = 20;
    }
    if (percentage > 60) {
      percentage = 60;
    }

    const mainPercentage = 99 - percentage;

    $('.left_menu_content.content_top').css('height', `${percentage}%`);
    $('.left_menu_content.content_bottom').css('height', `${mainPercentage}%`);

    $('.left_menu_content .menu_list').css(
      'height',
      $('.left_menu_content.content_top').height() - tabHeight
    );
    $('.left_menu_content .projects_list_wrap').css(
      'height',
      $('.left_menu_content.content_bottom').height() - tabHeight - 70
    );

    $('.left_menu_content .projects_list').css(
      'height',
      $('.left_menu_content .projects_list_wrap').height() - (38 * 2) // prettier-ignore
    );
  }

  updateProjectListState = (projectList, nextProjectList, pagination, state, page) => {
    const updatedProjectList = page === 1 ? nextProjectList : [...projectList, ...nextProjectList];
    this.setState({
      isLoadingTree: false,
      nextProjectPage: pagination.next,
      projectSize: pagination.per_page,
      hasMoreProject: pagination.next !== null,
      projectList: updatedProjectList,
      loadingIndex: '',
      isShowMoreLoading: false,
    });
    state.pages.setProjectList(updatedProjectList);
  };

  updateProjectVersionState = (projectList, nextProjectList, versionIndex, pagination, selectedIndex, activeIndex, hasMoreProjectVersion, state, page) => {
    const projectVersionIds = nextProjectList.map((item) => { return item.data.target_id.project_version_id; });
    let currentProjectId;
    if (projectList[versionIndex].data) {
      currentProjectId = projectList[versionIndex].data.id;
    } else {
      currentProjectId = null;
    }

    if (!currentProjectId) {
      return;
    }

    let newState = [...selectedIndex.project_version];

    if (activeIndex.includes(currentProjectId)) {
      if (selectedIndex.project.includes(currentProjectId)) {
        projectVersionIds.forEach((id) => {
          if (!newState.includes(id)) newState.push(id);
        });
      } else {
        newState = newState.filter((id) => { return !projectVersionIds.includes(id); });
      }
    }

    const updatedHasMoreProjectVersion = hasMoreProjectVersion.filter((item) => { return item.parentIndex !== versionIndex; });
    if (pagination.next !== null) {
      updatedHasMoreProjectVersion.push({ parentIndex: versionIndex, isNext: true });
    }

    if (page === 1 && projectList[versionIndex].children.length !== 0) {
      this.setState({
        isLoadingTree: false,
        loadingIndex: '',
        isShowMoreLoading: false,
      });
      return;
    }

    const updatedProjectList = projectList.map((item, idx) => { return (idx === versionIndex ? { ...item, children: [...item.children, ...nextProjectList] } : item); });

    this.setState({
      isLoadingTree: false,
      projectList: updatedProjectList,
      selectedIndex: {
        ...selectedIndex,
        project_version: newState,
      },
      hasMoreProjectVersion: updatedHasMoreProjectVersion,
      loadingIndex: '',
      isShowMoreLoading: false,
    });

    state.pages.setProjectList(updatedProjectList);
  };

  toggleSelectMode = () => {
    const { state } = this.props;
    const { isSelectable, projectList, activeIndex } = this.state;
    const newState = {
      project: [],
      project_version: [],
    };

    if (!isSelectable) {
      this.isSetParamsWithProjectId = false;
      const { searchParams } = this.props;
      const [URLSearchParams] = searchParams;
      const existingParams = this.extractExistingParams(URLSearchParams);

      if (existingParams.project && existingParams.project.length !== 0) {
        newState.project = existingParams.project.map((item) => {
          return Number(item);
        });
        this.isSetParamsWithProjectId = true;
      }

      if (existingParams.project_version && existingParams.project_version.length !== 0) {
        newState.project_version = existingParams.project_version.map((item) => {
          return Number(item);
        });
      } else if (this.isSetParamsWithProjectId) {
        const currentProjectIndex = projectList.findIndex((item) => {
          return item.data.id === Number(existingParams.project[0]);
        });

        const currentProjectId = projectList[currentProjectIndex].data.id;
        if (activeIndex.indexOf(currentProjectId) > -1) {
          const currentProjectIds = projectList[currentProjectIndex].children.map((item) => {
            return item.data.id;
          });
          newState.project_version = currentProjectIds;
        }
      }

      this.setState({
        isSelectable: !isSelectable,
        selectedIndex: newState,
      });
      state.pages.setSelecteModeValue(true);
    } else {
      this.initProjectFilter();
    }
  };

  toggleRow = (index, targetId, targetObject, currentObject, toggle) => {
    const {
      activeIndex, projectList, hasMoreProjectVersion, hasMoreReport, projectVersionSize, isSelectable
    } = this.state;

    const newActiveIndexSet = new Set(activeIndex);

    if (targetObject === 'project_version') {
      if (newActiveIndexSet.has(targetId)) {
        newActiveIndexSet.delete(targetId);

        const filterByVersionIndex = (item) => { return item.parentIndex !== index; };
        this.setState({
          projectList: Update(projectList, {
            [index]: { children: { $set: [] } },
          }),
          activeIndex: [...newActiveIndexSet],
          hasMoreProjectVersion: hasMoreProjectVersion.filter(filterByVersionIndex),
          hasMoreReport: hasMoreReport.filter(filterByVersionIndex),
        });
      } else {
        newActiveIndexSet.add(targetId);
        this.setState({
          targetObject,
          parentId: targetId,
          activeIndex: [...newActiveIndexSet],
        }, () => {
          this.getLeftProjectList(1, projectVersionSize, index, 'update');
        });

        if (toggle) {
          this.selectedTags(currentObject, targetId);
        }
      }
    }

    if (toggle && isSelectable) {
      this.handleCheckChange('', targetId, currentObject);
    }
  };

  navigateProjectSettings = () => {
    const { navigate } = this.props;
    navigate('settings/project');
  };

  saveProjectFilter = () => {
    const { saveFilterArray } = this.state;
    const { t } = this.props;
    const data = {
      name: saveFilterArray.name,
      projects: saveFilterArray.projects,
      project_versions: saveFilterArray.project_versions,
    };
    this.setState({
      isLoadingWithModal: true,
    }, () => {
      api
        .createProjectFilter(data)
        .then(() => {
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('navibar.saved_this_filter');
          this.setState({
            isOpenAlertModal: true,
            isLoadingWithModal: false,
            isOpenSaveFilter: false,
            isErrorWithAPI: false,
            isRequestSave: false,
          }, () => {
            this.closeMFFModal();
            this.getProjectFilters();
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');

          if (o.error === '422-023') {
            this.modalBody = t('modal.error.error_422_091_param');
          }

          if (o.error === '422-211') {
            this.modalBody = t('modal.error.error_422_211_value');
          }

          this.setState({
            isOpenAlertModal: true,
            isLoadingWithModal: false,
            isOpenSaveFilter: false,
            isErrorWithAPI: false,
            isRequestSave: false,
            currentIdWithDelete: '',
          });
        });
    });
  };

  deleteProjectFilter = () => {
    const { t } = this.props;
    const { currentIdWithDelete } = this.state;
    const obj = {
      filter_ids: [currentIdWithDelete],
    };
    this.setState({
      isLoadingWithModal: true,
    }, () => {
      api
        .deleteProjectFilter(obj)
        .then((res) => {
          const data = res.response;
          this.modalAction = t('modal.title.notice');
          this.modalBody = t('navibar.deleted_this_filter');
          if (data.destroy_ids && data.destroy_ids.indexOf(currentIdWithDelete) > -1) {
            this.setState({
              isOpenAlertModal: true,
              isLoadingWithModal: false,
              isOpenSaveFilter: false,
              isErrorWithAPI: false,
              isRequestSave: false,
              currentIdWithDelete: '',
            }, () => {
              this.getProjectFilters();
            });
          }
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');

          if (o.error === '422-023') {
            this.modalBody = t('modal.error.error_422_091_param');
          }

          if (o.error === '422-217') {
            this.modalBody = t('modal.error.error_422_211_value');
          }
          this.setState({
            isOpenAlertModal: true,
            isLoadingWithModal: false,
            isOpenSaveFilter: false,
            isErrorWithAPI: false,
            isRequestSave: false,
            currentIdWithDelete: '',
          });
        });
    });
  };

  extractExistingParams = (searchParams) => {
    const entries = Array.from(searchParams.entries());
    // eslint-disable-next-line no-return-assign
    return entries.reduce((acc, a) => { return ((acc[a[0]] = acc[a[0]] || []).push(a[1]), acc); }, {});
  };

  updateSelectedIndexFromOthers() {
    const {
      searchKeyword, projectVersionSize, currentSorted, projectList, hasMoreProjectVersion
    } = this.state;
    const { searchParams, state, t } = this.props;
    const [URLSearchParams] = searchParams;
    const existingParams = this.extractExistingParams(URLSearchParams);
    this.modalAction = t('modal.title.notice');
    this.modalBody = t('navibar.load_filters');
    let project;
    let project_version;
    let activeMenuIndex;
    let versionArray = [];
    let updateActiveIndex = [];
    const cloneArray = [...projectList];

    if (existingParams.project) {
      const toNumber = existingParams.project.map((item) => {
        return Number(item);
      });
      project = toNumber;
    } else {
      project = [];
    }

    if (existingParams.project_version) {
      const toNumber = existingParams.project_version.map((item) => {
        return Number(item);
      });
      project_version = toNumber;
    } else {
      project_version = [];
    }

    if (project.length !== 0 && existingParams.project_version) {
      const toNumber = existingParams.project.map((item) => {
        return Number(item);
      });
      activeMenuIndex = toNumber;
    } else {
      activeMenuIndex = [];
    }

    const newState = {
      project,
      project_version,
    };

    if (project_version.length !== 0 && project.length !== 0) {
      project.map(async (item) => {
        const res = await api.getLeftProjectList({
          search: searchKeyword,
          target_object: 'project_version',
          object_parent_id: item,
          page: 1,
          limit: projectVersionSize,
          order: currentSorted,
        });
        const currentProjectIndex = projectList.findIndex((x) => {
          return x.data.id === item;
        });
        if (res.response.length !== 0) {
          let currentProjectVersionIds = [];
          const nextProjectList = res.response.map((y) => {
            currentProjectVersionIds.push(y.id);
            return {
              data: y,
              children: [],
            };
          });

          let newData;
          const isNext = res.pagination.next !== null;
          const newObject = {
            parentIndex: currentProjectIndex,
            isNext,
          };

          if (hasMoreProjectVersion.length !== 0) {
            newData = hasMoreProjectVersion.filter((o) => {
              return o.parentIndex !== currentProjectIndex;
            });
          } else {
            newData = hasMoreProjectVersion;
          }
          currentProjectVersionIds = currentProjectVersionIds.filter((p) => {
            return project_version.includes(p);
          });

          if (versionArray.length === 0) {
            versionArray = Update(cloneArray, {
              [currentProjectIndex]: {
                children: {
                  $set: nextProjectList,
                },
              },
            });
            updateActiveIndex = [item];
          } else {
            versionArray = Update(versionArray, {
              [currentProjectIndex]: {
                children: {
                  $set: nextProjectList,
                },
              },
            });
            updateActiveIndex = [...updateActiveIndex, item];
          }

          state.pages.setProjectList(versionArray);

          this.setState({
            isLoadingTree: false,
            activeIndex: updateActiveIndex,
            selectedIndex: newState,
            projectList: versionArray,
            hasMoreProjectVersion: [...newData, newObject],
            loadingIndex: '',
            isShowMoreLoading: false,
            uploadedCount: this.currentCount,
            isOpenSaveFilter: false,
            isLoadingWithModal: false,
            isSelectable: true,
          });
        }
      });
    } else if (project.length !== 0) {
      this.setState({
        isSelectable: true,
        selectedIndex: newState,
        activeIndex: activeMenuIndex,
        isOpenSaveFilter: false,
        isLoadingWithModal: false,
      });
    } else {
      this.setState({
        isOpenSaveFilter: false,
        isLoadingWithModal: false,
      });
    }
    state.pages.setUpdateValueFromTree(false);
  }

  updateFilterStatus(data) {
    const {
      projectList,
      projectVersionSize,
      currentSorted,
      searchKeyword,
      hasMoreProjectVersion,
      selectedIndex,
    } = this.state;
    const { searchParams, state, t } = this.props;
    const [URLSearchParams, setSearchParams] = searchParams;
    const existingParams = this.extractExistingParams(URLSearchParams);

    const project_ids = data.projects;
    const project_version_ids = data.project_versions;
    const cloneArray = [...projectList];
    let versionArray = [];
    let updateActiveIndex = [];
    const updateSelectedIndex = {
      project: [],
      project_version: [],
    };

    project_ids.map(async (item) => {
      if (project_version_ids.length !== 0) {
        try {
          const res = await api.getLeftProjectList({
            search: searchKeyword,
            target_object: 'project_version',
            object_parent_id: item,
            page: 1,
            limit: projectVersionSize,
            order: currentSorted,
          });
          const currentProjectIndex = projectList.findIndex((x) => {
            return x.data.id === item;
          });
          if (res.response.length !== 0) {
            let currentProjectVersionIds = [];
            const nextProjectList = res.response.map((y) => {
              currentProjectVersionIds.push(y.id);
              return {
                data: y,
                children: [],
              };
            });

            let newData;
            const isNext = res.pagination.next !== null;
            const newObject = {
              parentIndex: currentProjectIndex,
              isNext,
            };

            if (hasMoreProjectVersion.length !== 0) {
              newData = hasMoreProjectVersion.filter((o) => {
                return o.parentIndex !== currentProjectIndex;
              });
            } else {
              newData = hasMoreProjectVersion;
            }
            currentProjectVersionIds = currentProjectVersionIds.filter((p) => {
              return project_version_ids.includes(p);
            });

            if (versionArray.length === 0) {
              versionArray = Update(cloneArray, {
                [currentProjectIndex]: {
                  children: {
                    $set: nextProjectList,
                  },
                },
              });
              updateActiveIndex = [item];
              updateSelectedIndex.project = [item];
              updateSelectedIndex.project_version = currentProjectVersionIds;
            } else {
              versionArray = Update(versionArray, {
                [currentProjectIndex]: {
                  children: {
                    $set: nextProjectList,
                  },
                },
              });
              updateActiveIndex = [...updateActiveIndex, item];
              updateSelectedIndex.project = [...updateSelectedIndex.project, item];
              updateSelectedIndex.project_version = [...updateSelectedIndex.project_version, ...currentProjectVersionIds];
            }

            state.pages.setProjectList(versionArray);

            this.setState({
              isLoadingTree: false,
              activeIndex: updateActiveIndex,
              selectedIndex: updateSelectedIndex,
              projectList: versionArray,
              hasMoreProjectVersion: [...newData, newObject],
              loadingIndex: '',
              isShowMoreLoading: false,
              uploadedCount: this.currentCount,
              isOpenSaveFilter: false,
              isLoadingWithModal: false,
              isSelectable: true,
              selectedFilter: data.value,
            });
          }
        } catch (err) {
          console.error('Error fetching projectlist:', err);

          this.modalAction = t('modal.title.attention');
          this.modalBody = t('modal.new_scan.error.error_unknown');

          this.setState({
            isOpenAlertModal: true,
            isLoadingTree: false,
            loadingIndex: '',
            isShowMoreLoading: false,
            isOpenSaveFilter: false,
            isLoadingWithModal: false,
          });
        }
      } else {
        this.setState({
          activeIndex: [],
          selectedIndex: {
            ...selectedIndex,
            project: project_ids,
            project_version: [],
          },
          isOpenSaveFilter: false,
          isLoadingWithModal: false,
          isSelectable: true,
          selectedFilter: data.value,
        });
      }

      existingParams.project = project_ids;
      if (project_version_ids.length !== 0) {
        existingParams.project_version = project_version_ids;
      }
      setSearchParams(existingParams);
    });
  }

  addParamsArrayValue(searchParams, key, value, parentId) {
    const { isSelectable } = this.state;

    let newParams = {};

    if (key === 'project') {
      newParams[key] = [value];
    } else if (key === 'project_version') {
      newParams = { project: [parentId], [key]: [value] };
    }

    if (!isSelectable) {
      this.setState({
        queryString: key === 'project' ? `project_${value}` : `project_${parentId}_${key}_${value}`,
      });
    }

    return newParams;
  }

  updateExistingParamsArrayValue(searchParams, key, value, parentId) {
    const { isSelectable, projectList } = this.state;

    const existingParams = this.extractExistingParams(searchParams);

    if (key === 'project') { //project
      if (existingParams.project_version) {
        if (!isSelectable) {
          if (existingParams.project_version.length !== 0) {
            delete existingParams.project_version;
          }
        } else if (existingParams.project_version.length === 0) {
          delete existingParams.project_version;
        } else {
          const currentTargetProjectIndex = projectList.findIndex((item) => {
            return item.data.id === value;
          });
          const projectVersionIds = projectList[currentTargetProjectIndex].children.map((item) => {
            return item.data.id;
          });
          if (projectVersionIds && projectVersionIds.length !== 0) {
            existingParams.project_version = existingParams.project_version.filter((item) => {
              return projectVersionIds.indexOf(Number(item)) === -1;
            });
          }
        }
      }

      if (existingParams[key]) {
        if (!isSelectable) {
          existingParams[key] = [value];
          this.setState({
            queryString: `${[key]}_${value}`,
          });
          return existingParams;
        }
        if (existingParams[key].indexOf(value) === -1) {
          existingParams[key].push(value);
        }
        return existingParams;
      }
    }

    //project_version
    if (existingParams[key] && existingParams[key].length !== 0) {
      if (!isSelectable) {
        if (existingParams.project.indexOf(parentId.toString()) === -1) {
          existingParams.project = [parentId];
        }
        existingParams[key] = [value];
        this.setState({
          queryString: `project_${parentId}_${[key]}_${value}`,
        });
        return existingParams;
      }
      if (existingParams.project && existingParams.project.indexOf(parentId.toString()) === -1) {
        existingParams.project.push(parentId.toString());
      }
      if (existingParams[key].indexOf(value.toString()) === -1) {
        existingParams[key].push(value.toString());
      }
      return existingParams;
    }
    existingParams[key] = [value.toString()];
    return existingParams;
  }

  removeExistingParamsArrayValue(searchParams, key, value, parentId) {
    const { projectList, activeIndex, selectedIndex } = this.state;
    const existingParams = this.extractExistingParams(searchParams);

    if (key === 'project') {
      if (existingParams[key]) {
        existingParams.project = existingParams.project.filter((item) => {
          return item !== value.toString();
        });

        const currentTargetProjectIndex = projectList.findIndex((item) => {
          return item.data.id === value;
        });

        if (activeIndex.indexOf(value) > -1) {
          const projectVersionIds = projectList[currentTargetProjectIndex].children.map((item) => {
            return item.data.id;
          });

          if (existingParams.project_version) {
            existingParams.project_version = existingParams.project_version.filter((item) => {
              return projectVersionIds.indexOf(Number(item)) === -1;
            });
          }
        }

        if (!existingParams.project_version || (existingParams.project_version && existingParams.project_version.length === 0)) {
          delete existingParams.project_version;
        }

        if (!existingParams.project || (existingParams.project && existingParams.project.length === 0)) {
          delete existingParams.project;
        }
        return existingParams;
      }
      if (selectedIndex.project) {
        const filteredProjectIds = selectedIndex.project.filter((item) => {
          return item !== value;
        });

        if (filteredProjectIds.length !== 0) {
          filteredProjectIds.map((item, index) => {
            if (index === 0) {
              existingParams.project = [item.toString()];
              return existingParams;
            }
            existingParams.project.push(item.toString());
            return existingParams;
          });
        }
        return existingParams;
      }
      return existingParams;
    }

    const currentTargetProjectIndex = projectList.findIndex((item) => {
      return item.data.id === parentId;
    });

    const projectVersionIds = projectList[currentTargetProjectIndex].children.map((item) => {
      return item.data.id;
    });

    if (existingParams[key]) {
      if (existingParams.project_version.indexOf(value.toString()) === -1) {
        const filteredProjectVersionIds = projectVersionIds.filter((item) => {
          return item !== value;
        });
        if (filteredProjectVersionIds.length !== 0) {
          existingParams.project_version = [...existingParams.project_version, ...filteredProjectVersionIds.map(String)];
          existingParams.project = existingParams.project.filter((item) => {
            return item !== parentId.toString();
          });

          if (existingParams.project && existingParams.project.length === 0) {
            delete existingParams.project;
          }
          return existingParams;
        }
        existingParams.project = existingParams.project.filter((item) => {
          return item !== parentId.toString();
        });
        if (existingParams.project && existingParams.project.length === 0) {
          delete existingParams.project;
        }
        return existingParams;
      }
      existingParams.project_version = existingParams.project_version.filter((item) => {
        return item !== value.toString();
      });

      if (existingParams.project_version && existingParams.project_version.length === 0) {
        delete existingParams.project_version;
      }

      if (existingParams.project) {
        existingParams.project = existingParams.project.filter((item) => {
          return item !== parentId.toString();
        });
        if (existingParams.project.length === 0) {
          delete existingParams.project;
          return existingParams;
        }
        return existingParams;
      }
      return existingParams;
    }

    const filteredProjectVersionIds = projectVersionIds.filter((item) => {
      return item !== value;
    });

    if (filteredProjectVersionIds.length !== 0) {
      existingParams.project_version = filteredProjectVersionIds.map(String);
      existingParams.project = existingParams.project.filter((item) => {
        return item !== parentId.toString();
      });

      if (existingParams.project && existingParams.project.length === 0) {
        delete existingParams.project;
      }

      return existingParams;
    }

    if (existingParams.project) {
      existingParams.project = existingParams.project.filter((item) => {
        return item !== parentId.toString();
      });
    }

    if (existingParams.project && existingParams.project.length === 0) {
      delete existingParams.project;
    }

    if (selectedIndex.project_version) {
      const filteredVersionIds = selectedIndex.project_version.filter((item) => {
        return projectVersionIds.indexOf(item) === -1;
      });

      if (filteredVersionIds.length !== 0) {
        filteredVersionIds.map((item, index) => {
          if (index === 0) {
            existingParams.project_version = [item.toString()];
            return existingParams;
          }
          existingParams.project_version.push(item.toString());
          return existingParams;
        });
      }
      return existingParams;
    }

    return existingParams;
  }

  selectedTags(currentObject, targetId, parentId) {
    const { searchParams } = this.props;
    const [URLSearchParams, setSearchParams] = searchParams;

    const isProjectContext = parentId === undefined;
    const isEmptyCurrentObject = URLSearchParams.getAll(currentObject).length === 0;
    const isEmptyRelatedParam = URLSearchParams.getAll(isProjectContext ? 'project_version' : 'project').length === 0;

    if (isEmptyCurrentObject && isEmptyRelatedParam) {
      setSearchParams(this.addParamsArrayValue(URLSearchParams, currentObject, targetId, parentId));
    } else {
      setSearchParams(this.updateExistingParamsArrayValue(URLSearchParams, currentObject, targetId, parentId));
    }
  }

  generateTreeData() {
    const { selectedIndex, isSelectable } = this.state;
    const { state, searchParams } = this.props;
    const [URLSearchParams] = searchParams;

    let newState;
    const cloneArray = toJS(state.pages.projectList);

    if (isSelectable) {
      newState = cloneArray.filter((item) => {
        const project_children = item.children;
        let projectCnt = 0;
        if (selectedIndex.project.includes(item.data.id)) {
          return true;
        }

        project_children.forEach((x) => {
          const project_version_id = x.data.id;
          if (selectedIndex.project_version.includes(project_version_id)) {
            projectCnt++;
          }
        });
        if (projectCnt > 0) {
          return true;
        }
        return false;
      });

      newState = newState.map((item) => {
        item.children = item.children.filter((x) => {
          return selectedIndex.project_version.includes(x.data.id);
        });
        return item;
      });
    } else {
      const existingParams = this.extractExistingParams(URLSearchParams);

      if (existingParams.project) {
        newState = cloneArray.filter((item) => {
          return existingParams.project.includes(item.data.id.toString());
        });

        if (existingParams.project_version) {
          newState = newState.map((item) => {
            item.children = item.children.filter((x) => {
              return existingParams.project_version.includes(x.data.id.toString());
            });
            return item;
          });
        }
      }
    }

    return newState;
  }

  initArrayData() {
    const { activeTab, projectList, filterList } = this.state;

    if (activeTab === 'recent') {
      this.getRecentData();
    }
    if (activeTab === 'bookmark') {
      this.initBookmarkList();
    }

    if (projectList.length === 0) {
      this.getLeftProjectList();
    }

    if (filterList.length === 0) {
      this.getProjectFilters();
    }
  }

  initBookmarkList() {
    this.setState(
      {
        bookmarkDataList: [],
        activeBookmark: this.activeBookmark,
      },
      () => {
        this.getBookmarkData();
      }
    );
  }

  initUpoloadedList() {
    const { activeTabBottom } = this.state;

    if (activeTabBottom === 'projects') {
      return;
    }
    this.setState(
      {
        searchKeyword: '',
        uploadedDataList: [],
        uploadedCount: this.currentCount,
      },
      () => {
        this.search.value = '';
        this.getUploadedData();
      }
    );
  }

  initProjectList() {
    this.setState(
      {
        searchKeyword: '',
        projectList: [],
        activeIndex: [],
        currentSorted: 'uploaded',
        parentId: 0,
        targetObject: 'project',
        uploadedCount: this.currentCount,
      },
      () => {
        this.search.value = '';
        this.getLeftProjectList();
      }
    );
  }

  initProjectFilter() {
    const { searchParams, state } = this.props;
    const [URLSearchParams, setSearchParams] = searchParams;
    if (URLSearchParams.size === 0) {
      state.pages.setSelecteModeValue(false);
      return this.setState({
        isSelectable: false,
      });
    }
    const existingParams = this.extractExistingParams(URLSearchParams);
    delete existingParams.project;
    delete existingParams.project_version;

    setSearchParams(existingParams);

    this.setState({
      searchKeyword: '',
      queryString: '',
      parentId: 0,
      targetObject: 'project',
      selectedIndex: {
        project: [],
        project_version: [],
      },
      activeIndex: [],
      isSelectable: false,
      projectList: [],
      uploadedCount: this.currentCount,
      selectedFilter: '',
    }, () => {
      this.search.value = '';
      this.getLeftProjectList();
    });
    state.pages.setSelecteModeValue(false);
    state.pages.initSelectedIndexValue();
  }

  clearSearch() {
    const { activeTabBottom } = this.state;

    if (activeTabBottom === 'files') {
      return this.setState(
        {
          searchKeyword: '',
          uploadedDataList: [],
        },
        () => {
          this.search.value = '';
          this.getUploadedData();
        }
      );
    }
    return this.setState(
      {
        searchKeyword: '',
        projectList: [],
        activeIndex: [],
        targetObject: 'project',
        parentId: 0,
      },
      () => {
        this.search.value = '';
        this.getLeftProjectList();
      }
    );
  }

  convertString(value) {
    const firstL = value.slice(0, 1).toUpperCase();
    const rest = value.slice(1).toLowerCase();
    return firstL.concat(rest);
  }

  closeModal() {
    this.setState({
      isOpenAlertModal: false,
      isOpenSaveFilter: false,
    });
  }

  closeMFFModal() {
    this.setState({
      isOpenMFF: false,
    });
  }

  renderShowMore(projectIndex, targetId, type) {
    const {
      hasMoreProjectVersion, hasMoreReport, isShowMoreLoading, projectSize
    } = this.state;
    const { t } = this.props;

    if (type === 'project_version') {
      const currentIndex = hasMoreProjectVersion.findIndex((item) => {
        return item.parentIndex === projectIndex;
      });

      if (typeof currentIndex === 'undefined' || currentIndex === -1) {
        return null;
      }

      if (hasMoreProjectVersion[currentIndex].isNext) {
        if (isShowMoreLoading) {
          return (
            <li>
              <img
                src={progress}
                role="presentation"
                style={{
                  width: 14,
                  height: 14,
                  margin: '5px 0 0 15px',
                }}
                alt=""
              />
            </li>
          );
        }
        return (
          <li className="show_more">
            <a
              style={{ paddingLeft: '25px' }}
              onClick={() => {
                return this.getMoreListData(projectIndex, targetId, 'project_version');
              }}
              onKeyUp={() => {
                return this.getMoreListData(projectIndex, targetId, 'project_version');
              }}
            >
              {t('my_page.show_more')}
            </a>
          </li>
        );
      }
      return null;
    } if (type === 'report') {
      const string = projectIndex.split('-');
      const currentIndex = hasMoreReport.findIndex((item) => {
        return item.parentIndex === Number(string[0]) && item.childIndex === Number(string[1]);
      });

      if (typeof currentIndex === 'undefined') {
        return null;
      }

      if (hasMoreReport[currentIndex].isNext) {
        if (isShowMoreLoading) {
          return (
            <li>
              <img
                src={progress}
                role="presentation"
                style={{
                  width: 14,
                  height: 14,
                  margin: '5px 0 0 15px',
                }}
                alt=""
              />
            </li>
          );
        }
        return (
          <li className="show_more">
            <a
              style={{ paddingLeft: '40px' }}
              onClick={() => {
                return this.getMoreListData(projectIndex, targetId, 'report');
              }}
              onKeyUp={() => {
                return this.getMoreListData(projectIndex, targetId, 'report');
              }}
            >
              {t('my_page.show_more')}
            </a>
          </li>
        );
      }
      return null;
    }

    return (
      <li className="show_more">
        <a
          style={{ paddingLeft: '10px' }}
          onClick={() => {
            return this.getMoreListData(projectIndex, projectSize, 'project');
          }}
          onKeyUp={() => {
            return this.getMoreListData(projectIndex, projectSize, 'project');
          }}
        >
          {t('my_page.show_more')}
        </a>
      </li>
    );
  }

  render() {
    const {
      quotaArray,
      recentList,
      error,
      activeTab,
      bookmarkDataList,
      isLoadingBookmark,
      isSelectable,
      errSearch,
      isLoadingTree,
      projectList,
      activeIndex,
      hasMoreProject,
      loadingIndex,
      nextProjectPage,
      isOpenScan,
      selectedIndex,
      queryString,
      filterList,
      selectedFilter,
      isOpenAlertModal,
      isOpenSaveFilter,
      isLoadingWithModal,
      isErrorWithAPI,
      isRequestSave,
      isOpenMFF,
      rowData,
      isShowQuota,
      isOpenImport,
    } = this.state;

    const { t } = this.props;
    let leftData;

    const renderIndeterminate = (index) => {
      if (projectList.length === 0) {
        return false;
      }

      const childrenids = projectList[index].children.map((item) => {
        return item.data.id;
      });

      const selectedRow = selectedIndex.project_version.filter((item) => {
        return childrenids.indexOf(item) > -1;
      });

      if (selectedRow.length !== 0 && selectedRow.length < childrenids.length) {
        return true;
      }
      return false;
    };

    if (quotaArray.length > 0) {
      if (quotaArray[0].capacity !== -1 && quotaArray[0].spent !== 0) {
        leftData = (quotaArray[0].spent / quotaArray[0].capacity) * 100;
      }
      leftData = 100;
    }

    return (
      <div
        className="left_menu"
        ref={this.setNavigationBarRef}
      >
        <div className="button_wrap">
          <a
            className="new_scan"
            onClick={this.handleScanOpen}
            onKeyUp={this.handleScanOpen}
          >
            {t('project.message.new_scan')}
          </a>
          <a
            className="sbom_import"
            onClick={this.handleSbomImportOpen}
            onKeyUp={this.handleSbomImportOpen}
          >
            + SBOM Import
          </a>
        </div>
        <div className="progress">
          <div className="progress_bar" style={{ width: `${leftData}%` || '0%' }} />
          <div className="progress_detail_wrap">
            {
              isShowQuota && quotaArray.length > 0
              && quotaArray.map((item) => {
                return (
                  <div key={item.spent.toString()} className="progress_detail">
                    <div className="left_item">
                      <p className="label">
                        {/*item.type === 'daily' && t('modal.new_scan.title.today_used')*/}
                        {/*item.type === 'total' && t('modal.new_scan.title.total_used')*/}
                        {t('modal.new_scan.title.total_used')}
                      </p>
                      <p className="value">{item.spent}</p>
                    </div>
                    <div className="right_item">
                      <p className="label">
                        {/*item.type === 'daily' && t('modal.new_scan.title.today_left')*/}
                        {/*item.type === 'total' && t('modal.new_scan.title.total_left')*/}
                        {t('modal.new_scan.title.total_left')}
                      </p>
                      <p className="value">{item.capacity === -1 ? t('modal.new_scan.title.unlimited') : item.capacity}</p>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
        <div className="left_menu_contents_wrap">
          <div className="left_menu_content content_top">
            <div className="left_menu_content_tab">
              <a
                className={cx('tab_item', {
                  active: activeTab === 'recent',
                })}
                onClick={this.handleTabChange}
                onKeyUp={this.handleTabChange}
              >
                {t('my_page.title.recent')}
              </a>
              <a
                className={cx('tab_item', {
                  active: activeTab === 'bookmark',
                })}
                onClick={this.handleTabChange}
                onKeyUp={this.handleTabChange}
              >
                {t('my_page.title.bookmarks')}
              </a>
              {activeTab === 'bookmark' && (
                <a
                  className="tab_item more"
                  onClick={this.handleEditBookmark}
                  onKeyUp={this.handleEditBookmark}
                >
                  <img src={add} alt="" />
                </a>
              )}
            </div>
            <div>
              {activeTab === 'recent' && (
                <div className="menu_list">
                  {recentList.length === 0 ? (
                    <div className="empty_box">
                      <a
                        onClick={this.handleScanOpen}
                        onKeyUp={this.handleScanOpen}
                        style={{ cursor: 'pointer' }}
                      >
                        {t('project.message.new_scan')}
                      </a>
                      <p>{t('modal.new_scan.message.no_recently_files')}</p>
                    </div>
                  ) : (
                    <Scrollbars
                      renderTrackHorizontal={() => {
                        return <div />;
                      }}
                      renderThumbHorizontal={() => {
                        return <div />;
                      }}
                      ref={this.setRecentListScrollRef}
                    >
                      <ul>
                        {recentList.map((list) => {
                          return (
                            <li
                              key={list.id.toString()}
                            >
                              <a
                                onClick={() => {
                                  return this.handleNav(
                                    list.target_id.uploaded_file_id,
                                    list.view_point
                                  );
                                }}
                                onKeyUp={() => {
                                  return this.handleNav(
                                    list.target_id.uploaded_file_id,
                                    list.view_point
                                  );
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                <p className="name">{list.name}</p>
                                <p className="type">
                                  {this.convertString(list.view_point)}
                                  {' '}
                                  <span style={{ display: 'block', float: 'right', width: '60%' }}>
                                    {list.extra_data.project}
                                    {' '}
                                    /
                                    {' '}
                                    {list.extra_data.project_version}
                                  </span>
                                </p>

                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    </Scrollbars>
                  )}
                </div>
              )}
              {activeTab === 'bookmark' && (
                <div className="menu_list">
                  {bookmarkDataList.length === 0 ? (
                    <div className="empty_box">
                      <p>{t('modal.new_scan.message.no_bookmark_list')}</p>
                    </div>
                  ) : (
                    <Scrollbars
                      renderTrackHorizontal={() => {
                        return <div />;
                      }}
                      renderThumbHorizontal={() => {
                        return <div />;
                      }}
                      ref={this.setBookmarkListScrollRef}
                      onScroll={this.handleBookmarkScroll}
                    >
                      <ul>
                        {bookmarkDataList.map((list) => {
                          if (list.targetObject === 'report') {
                            return (
                              <li key={list.id.toString()}>
                                <a
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleBookmarkNav(
                                      list.targetId,
                                      list.viewPoint,
                                      list.targetObject
                                    );
                                  }}
                                  onKeyUp={() => {
                                    return this.handleBookmarkNav(
                                      list.targetId,
                                      list.viewPoint,
                                      list.targetObject
                                    );
                                  }}
                                >
                                  <p className="name">{list.name}</p>
                                  <p className="type">
                                    {this.convertString(list.viewPoint)}
                                    <span
                                      style={{ display: 'block', float: 'right', width: '60%' }}
                                    >
                                      {list.extraData.project}
                                      /
                                      {list.extraData.project_version}
                                    </span>
                                  </p>
                                </a>
                              </li>
                            );
                          } if (list.targetObject === 'project') {
                            return (
                              <li key={list.id.toString()}>
                                <a
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleBookmarkNav(
                                      list.targetId,
                                      list.viewPoint,
                                      list.targetObject,
                                      list.name
                                    );
                                  }}
                                  onKeyUp={() => {
                                    return this.handleBookmarkNav(
                                      list.targetId,
                                      list.viewPoint,
                                      list.targetObject,
                                      list.name
                                    );
                                  }}
                                >
                                  <p className="name">{list.name}</p>
                                  <p className="type">{this.convertString(list.viewPoint)}</p>
                                </a>
                              </li>
                            );
                          } if (list.targetObject === 'project_version') {
                            return (
                              <li
                                key={list.id.toString()}
                              >
                                <a
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.handleBookmarkNav(
                                      list.targetId,
                                      list.viewPoint,
                                      list.targetObject,
                                      list.extraData.project,
                                      list.name
                                    );
                                  }}
                                  onKeyUp={() => {
                                    return this.handleBookmarkNav(
                                      list.targetId,
                                      list.viewPoint,
                                      list.targetObject,
                                      list.extraData.project,
                                      list.name
                                    );
                                  }}
                                >
                                  <p className="name">
                                    {list.extraData.project}
                                    /
                                    {list.name}
                                  </p>
                                  <p className="type">{this.convertString(list.viewPoint)}</p>
                                </a>
                              </li>
                            );
                          }
                          return null;
                        })}
                        {error && <div className="error_log">{error}</div>}
                        {isLoadingBookmark && (
                          <Loader active={isLoadingBookmark} size="small" inline="centered" />
                        )}
                      </ul>
                    </Scrollbars>
                  )}
                </div>
              )}
            </div>
            <div className="dragbar" />
          </div>
          <div
            className="left_menu_content content_bottom"
          >
            <div className="left_menu_content_tab with_button">
              <a
                className="tab_item active"
                onClick={this.initProjectFilter}
                onKeyUp={this.initProjectFilter}
              >
                {t('my_page.projects')}
              </a>
              <div className="button_util_wrap_navbar">
                <ButtonGroup
                  icon
                >
                  {
                    isSelectable ? (
                      <Button
                        className="active"
                        onClick={this.toggleSelectMode}
                        onKeyUp={this.toggleSelectMode}
                        icon="checkmark"
                      />
                    ) : (
                      <Button
                        onClick={this.toggleSelectMode}
                        onKeyUp={this.toggleSelectMode}
                        icon="checkmark"
                      />
                    )
                  }
                  <Button
                    onClick={this.handleSaveFilterChange}
                    icon="save"
                  />
                  <Button
                    onClick={this.navigateProjectSettings}
                    icon="setting"
                  />
                </ButtonGroup>
              </div>
            </div>
            <div className="projects_list_wrap">
              <div className="projects_search_wrap">
                <img src={search} alt="" className="search_icon" />
                <input
                  type="text"
                  className="projects_search"
                  placeholder={t('modal.new_scan.place_holder.project_version_name')}
                  ref={(ref) => {
                    this.search = ref;
                  }}
                  onKeyPress={this.handleSearch}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                />
                <a className="reset_icon" onClick={this.clearSearch} onKeyUp={this.clearSearch}>
                  x
                </a>
                {errSearch && (
                  <Label basic color="red" pointing>
                    {t('contents_header.message.least_two_required_to_search')}
                  </Label>
                )}
              </div>
              <div>
                <div className="projects_list">
                  <Scrollbars
                    ref={this.setProjectListScrollRef}
                    onScroll={this.handleScroll}
                    renderTrackHorizontal={() => {
                      return <div />;
                    }}
                    renderThumbHorizontal={() => {
                      return <div />;
                    }}
                  >
                    <ul className="depth_1">
                      {projectList.length !== 0
                            && projectList.map((project, projectIndex) => {
                              return (
                                <li
                                  key={project.data.id.toString()}
                                  className={cx({
                                    expand: activeIndex.indexOf(project.data.id) > -1,
                                  })}
                                >
                                  <div
                                    className={cx('treeview_item_container', {
                                      selected: queryString === `project_${project.data.target_id.project_id}`,
                                    })}
                                  >
                                    {
                                      isSelectable
                                      && (
                                        <Checkbox
                                          indeterminate={renderIndeterminate(projectIndex)}
                                          value={project.data.target_id.project_id}
                                          checked={selectedIndex.project.indexOf(project.data.target_id.project_id) > -1}
                                          onChange={(e, data) => {
                                            return this.handleCheckChange(
                                              e,
                                              data.value,
                                              'project'
                                            );
                                          }}
                                        />
                                      )
                                    }
                                    <div
                                      className="treeview_item_toggle"
                                      onClick={() => {
                                        return this.toggleRow(
                                          projectIndex,
                                          project.data.target_id.project_id,
                                          'project_version',
                                          'project',
                                        );
                                      }}
                                      onKeyUp={() => {
                                        return this.toggleRow(
                                          projectIndex,
                                          project.data.target_id.project_id,
                                          'project_version',
                                          'project',
                                        );
                                      }}
                                    >
                                      <img
                                        className="fold_icon"
                                        src={foldImg}
                                        role="presentation"
                                        alt=""
                                      />
                                      <img
                                        className="expand_icon"
                                        src={expandImg}
                                        role="presentation"
                                        alt=""
                                      />
                                    </div>
                                    <div
                                      className="treeview_item_content"
                                      onClick={() => {
                                        return this.toggleRow(
                                          projectIndex,
                                          project.data.target_id.project_id,
                                          'project_version',
                                          'project',
                                          'tags'
                                        );
                                      }}
                                      onKeyUp={() => {
                                        return this.toggleRow(
                                          projectIndex,
                                          project.data.target_id.project_id,
                                          'project_version',
                                          'project',
                                          'tags'
                                        );
                                      }}
                                    >
                                      <span className="text">{project.data.name}</span>
                                    </div>
                                  </div>
                                  <ul className="depth_2">
                                    {project.children.length !== 0
                                      && project.children.map((projectVersion) => {
                                        return (
                                          <li
                                            key={projectVersion.data.id.toString()}
                                            style={{ paddingLeft: '22px' }}
                                          >
                                            <div
                                              className={cx('treeview_item_container', {
                                                selected: queryString === `project_${project.data.target_id.project_id}_project_version_${projectVersion.data.id}`,
                                              })}
                                            >
                                              {
                                                isSelectable
                                                && (
                                                  <Checkbox
                                                    value={projectVersion.data.id}
                                                    checked={selectedIndex.project_version.indexOf(projectVersion.data.id) > -1}
                                                    onChange={(e, data) => {
                                                      return this.handleCheckChange(
                                                        e,
                                                        data.value,
                                                        'project_version',
                                                        project.data.target_id.project_id,
                                                      );
                                                    }}
                                                  />
                                                )
                                              }
                                              {
                                                isSelectable ? (
                                                  <div
                                                    className="treeview_item_content"
                                                    onClick={(e) => {
                                                      return this.handleCheckChange(
                                                        e,
                                                        projectVersion.data.id,
                                                        'project_version',
                                                        project.data.target_id.project_id,
                                                      );
                                                    }}
                                                    onKeyUp={(e) => {
                                                      return this.handleCheckChange(
                                                        e,
                                                        projectVersion.data.id,
                                                        'project_version',
                                                        project.data.target_id.project_id,
                                                      );
                                                    }}
                                                  >
                                                    <span className="text">{projectVersion.data.name}</span>
                                                  </div>
                                                ) : (
                                                  <div
                                                    className="treeview_item_content"
                                                    onClick={() => {
                                                      return this.selectedTags(
                                                        'project_version',
                                                        projectVersion.data.id,
                                                        project.data.target_id.project_id,
                                                      );
                                                    }}
                                                    onKeyUp={() => {
                                                      return this.selectedTags(
                                                        'project_version',
                                                        projectVersion.data.id,
                                                        project.data.target_id.project_id,
                                                      );
                                                    }}
                                                  >
                                                    <span className="text">{projectVersion.data.name}</span>
                                                  </div>
                                                )
                                              }
                                            </div>
                                          </li>
                                        );
                                      })}
                                    {project.children.length !== 0
                                      && this.renderShowMore(
                                        projectIndex,
                                        project.data.target_id.project_id,
                                        'project_version'
                                      )}
                                    {isLoadingTree
                                      && loadingIndex === `${projectIndex}-project_version` && (
                                      <Loader
                                        size="small"
                                        active={isLoadingTree}
                                        inline="centered"
                                      />
                                    )}
                                  </ul>
                                </li>
                              );
                            })}
                      {hasMoreProject
                            && this.renderShowMore(nextProjectPage, 20, 'project')}
                      {isLoadingTree && loadingIndex === 'project' && (
                        <Loader size="small" active={isLoadingTree} inline="centered" />
                      )}
                    </ul>
                  </Scrollbars>
                </div>
              </div>
              <div className="newest">
                {
                  filterList.length !== 0 ? (
                    <Dropdown
                      selection
                      value={selectedFilter}
                      options={filterList}
                      selectOnBlur={false}
                      placeholder={t('modal.new_scan.place_holder.get_saved_filter')}
                      onChange={this.handleLoadFilterChange}
                    />
                  ) : (
                    <Dropdown
                      className="selection"
                      text={t('navibar.no_saved_filters')}
                    >
                      <Dropdown.Menu>
                        <Dropdown.Item>{t('navibar.no_saved_filters')}</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )
                }
              </div>
            </div>
          </div>
        </div>
        <NewScanModal
          isOpenScan={isOpenScan}
          closeModal={this.handleScanClose}
          translate={t}
        />
        <ImportPopup
          isOpenImport={isOpenImport}
          closeModal={this.handleSbomImportClose}
          translate={t}
        />
        <Modal
          open={isOpenAlertModal}
          onClose={this.closeModal}
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a className="center_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={isOpenSaveFilter}
          onClose={this.closeModal}
        >
          {
            isLoadingWithModal ? (
              <div className="modal_popup_wrap">
                <div className="modal_popup_box">
                  <div className="modal_popup">
                    <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                      <ClarLoader
                        style={{
                          position: 'relative',
                          width: '80%',
                          height: '80%',
                          marginBottom: '15%',
                        }}
                      />
                      <span
                        style={{
                          fontWeight: '500',
                          fontSize: '16px',
                          marginTop: '25%',
                          display: 'inline-block',
                        }}
                      >
                        {this.modalBody}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isErrorWithAPI ? (
                          <div className="button_wrap">
                            <a
                              className="center_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {t('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a
                              className="left_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {t('modal.button.no')}
                            </a>
                            {
                              isRequestSave ? (
                                <a
                                  className="right_button"
                                  onClick={this.saveProjectFilter}
                                  onKeyUp={this.saveProjectFilter}
                                >
                                  {t('modal.button.yes')}
                                </a>
                              ) : (
                                <a
                                  className="right_button"
                                  onClick={this.deleteProjectFilter}
                                  onKeyUp={this.deleteProjectFilter}
                                >
                                  {t('modal.button.yes')}
                                </a>
                              )
                            }
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
        <FilterFormWithSaveModal
          isOpenMFF={isOpenMFF}
          rowData={rowData}
          onSubmit={this.handleSaveFilterCallback}
          translate={t}
          closeModal={this.closeMFFModal}
        />
      </div>
    );
  }
}
export default WithRouter(withTranslation()(inject('state')(observer(ScanNavBar))));
